/**
 * Awards Hero block: switches to the next voting state when the countdown
 * ends, without a reload (the page is cached).
 *
 * Markup: template-parts/awards/blocks/hero.php. data-next holds the following
 * time-based states in order ({ state, lead, label, end }); each one gets the
 * lead text, the primary button label and the countdown target. A state
 * without a target (closed) hides the countdown.
 */

import { END_EVENT, setCountdownEnd } from './countdown';

export default function initHero(root) {
  const countdown = root.querySelector('[data-awards-countdown]');

  if (!countdown) {
    return;
  }

  const next = JSON.parse(root.dataset.next || '[]');
  const lead = root.querySelector('[data-hero-lead]');
  const cta = root.querySelector('[data-hero-cta]');

  document.addEventListener(END_EVENT, (event) => {
    if (event.detail.end !== Date.parse(countdown.dataset.end)) {
      return;
    }

    const state = next.shift();

    if (state) {
      root.dataset.state = state.state;
      lead.textContent = state.lead;
      cta.textContent = state.label;
    }

    if (state && state.end) {
      setCountdownEnd(countdown, state.end);
    } else {
      countdown.hidden = true;
    }
  });
}
